<header>
  <div class="left-side">
    @if (showMenu()) {
      <button matIconButton
              (click)="menuClick.emit()">
        <mat-icon>menu</mat-icon>
      </button>
    }
    <div aria-hidden="true" (click)="logoClick.emit()" class="logo-container">
      <div class="bauer-logo"></div>
      <div class="app-title">{{ appName() }}</div>
    </div>
  </div>
  <div class="right-side">
    <div>{{ email() }}</div>
    <div class="language-menu-trigger" [matMenuTriggerFor]="languageMenu">
      <img [ngSrc]="selectedLanguage().icon.path" [width]="24" [height]="16" [alt]="selectedLanguage().icon.name">
      <mat-icon class="chevron-icon">chevron-down
      </mat-icon>
    </div>
    <mat-menu #languageMenu="matMenu"
              class="language-menu">
      @for (language of languages; track language.code) {
        <button mat-menu-item
                (click)="onLanguageChange(language.code)">
          <mat-icon [svgIcon]="language.icon.name"
                    class="menu-icon"></mat-icon>
          {{ language.code }}
        </button>
      }
    </mat-menu>
    <button matIconButton
            (click)="logout()">
      <mat-icon class="logout-icon">log-out</mat-icon>
    </button>
  </div>
</header>
